module.exports = __webpack_public_path__ + "img/Group 1840@2x(1).ce05b0ac.png";